import React from "react";
import { CheckboxGroup } from "../../../../comum";
import { connect } from "react-redux";
import {
  getAdicionarDataReferencia,
  selecionarAdicaoDataReferencia,
} from "../../../../../state";
import { compose, mapProps } from "recompose";
import { withI18n } from "@quantum/i18n";

import "./checkbox-data-referencia.css";

const enhance = compose(
  withI18n,
  mapProps(({ translate }) => ({
    description: translate("configuracaoRelatorio.adicionarDataReferencia"),
  })),
  connect(
    state => ({
      selected: getAdicionarDataReferencia(state),
    }),
    dispatch => ({
      onChange: (ids: Array<Id>) =>
        dispatch(selecionarAdicaoDataReferencia(ids.length > 0)),
    })
  )
);

const CheckboxDataReferencia = ({
  selected = false,
  description,
  onChange,
}) => {
  return (
    <div className="ConfiguracaoMedida ConfigDataReferencia">
      <CheckboxGroup
        nome="adicionarDataReferencia"
        itens={[{ id: 1, description }]}
        campoId="id"
        campoDescricao="description"
        itensSelecionados={selected ? [1] : []}
        onChange={onChange}
      />
    </div>
  );
};

export default enhance(CheckboxDataReferencia);
